import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing, editable, isToggle, inlineEdit } from 'src/types/columnFlags';
const controlledActions = {
    create: [480],
    fetch: [481, 46],
    update: [482],
    delete: [483],
    downloadList: [481],
    uploadList: [480]
};
const columns = () => {
    return [
        // @ts-ignore
        { name: 'row_menu', type: 'row_menu', menuItemShortcuts: ['edit', 'copy_create'], hideWhenCreatingAndEditing },
        { name: 'id', style: 'width:50px', isInteger, hideWhenCreatingAndEditing },
        { name: 'name', inlineEdit, uiFilterTypes: ['selectedValuesFilter', 'textFilters'], style: 'white-space: nowrap' },
        { name: 'disabled', editable, isToggle },
        { name: 'description', inlineEdit, maxLines: 2, style: 'width:80px' },
        {
            name: 'entity',
            editable,
            uiFilterTypes: ['selectedValuesFilter', 'textFilters'],
            complexlyReferences: {
                table: 'meta.entities',
                reference_value_field: 'name',
                type: 'labelField',
                reference_label_field: 'name'
            }
        },
        { name: 'action', editable, isDropdownSelector: true, dropdownSelectorOptions: ['insert', 'select', 'update', 'delete'] },
        { name: 'conditions', editable },
        { name: 'excluded_fields', editable },
        { name: 'only_include_fields', editable },
        { name: 'value_and_argument_constraints', editable },
        { name: 'is_superset_of', editable },
        { name: 'created_at', hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'may_not_be_assigned_to_role_via_ui', label: 'May not be assigned to roles via UI', editable, isToggle, toggleColor: 'warning' }
    ];
};
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName: 'controlled_actions.controlled_actions',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Controlled actions'
});
export default localEntity;
